import React from "react";
import Title from "../../../../../components/Title";
import { DYNAMIC_ANALYSIS_EMPTY_MESSAGES } from "../consts";
import { RLCSYaraEntry } from "../../../@types/rldynamicanalysis/yara";
import { RLCloudSandboxYaraRuleSchema } from "./RLCloudSandboxYaraRuleSchema";
import RLCloudSandboxYaraGrid from "./RLCloudSandboxYaraGrid";
import "./rlcloudsandboxyara.module.scss";

type RlCloudSandboxYaraProps = {
  yaraData: RLCSYaraEntry[];
  reportTitle: string;
};

const RlCloudSandboxYara = ({
  yaraData,
  reportTitle
}: RlCloudSandboxYaraProps) => {
  const hasYARAMatches = yaraData.length > 0;

  return (
    <>
      <Title Level="h2" text={`YARA Matches (${reportTitle})`} />

      {hasYARAMatches ? (
        <div
          data-testid={`rlcs-yara-rule-table}`}
          className="rlcs-yara-matched-rules-table"
        >
          <RLCloudSandboxYaraGrid
            yaraData={yaraData}
            schema={RLCloudSandboxYaraRuleSchema}
          />
        </div>
      ) : (
        <b>{DYNAMIC_ANALYSIS_EMPTY_MESSAGES.yara}</b>
      )}
    </>
  );
};

export default RlCloudSandboxYara;
